<template>
  <div class="homepage-container">
    <!-- 媒体热点速览 -->
    <div class="hot-news-section">
      <div class="section-header">
        <h2 class="section-title">媒体热点速览</h2>
        <div class="refresh-info">
          <span>实时刷新</span>
          <el-select v-model="selectedHotNewsMedia" placeholder="请选择媒体" size="small" @change="onHotNewsMediaChange"
            class="media-select">
            <el-option v-for="media in hotNewsMediaOptions" :key="media.value" :label="media.label"
              :value="media.value" />
          </el-select>
        </div>
      </div>
      <div class="hot-news-list">
        <div v-for="(item, index) in hotNews" :key="item.id" class="hot-news-item" :class="{ 'hot': index < 3 }">
          <div class="news-rank" :class="getRankClass(index)">{{ index + 1 }}</div>
          <div class="news-content" :title="item.title">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <!-- 底部数据面板 -->
    <div class="data-panels">
      <!-- 名人热度指数 -->
      <div class="data-panel celebrity-panel">
        <div class="panel-header">
          <div class="header-content">
            <h3 class="panel-title">名人热度指数</h3>
            <div class="panel-subtitle">以天为统计周期</div>
          </div>
        </div>
        <div class="panel-content">
          <div class="table-header">
            <div class="col-rank">排名</div>
            <div class="col-name">账号名称</div>
            <div class="col-fans">累计粉丝</div>
            <div class="col-index">新增指数</div>
          </div>
          <div class="table-body">
            <div v-for="(item, index) in celebrityData" :key="item.id" class="table-row">
              <div class="col-rank">
                <div class="rank-number" :class="getRankClass(index)">{{ index + 1 }}</div>
                <div class="rank-change" :class="item.change > 0 ? 'up' : item.change < 0 ? 'down' : 'same'">
                  <span v-if="item.change > 0">▲</span>
                  <span v-else-if="item.change < 0">▼</span>
                  <span v-else-if="item.change !== 0">-</span>
                  <span v-if="item.change !== 0">{{ Math.abs(item.change) }}</span>
                </div>
              </div>
              <div class="col-name">
                <div class="user-info">
                  <img :src="item.avatar" :alt="item.name" class="user-avatar" />
                  <span class="user-name">{{ item.name }}</span>
                </div>
              </div>
              <div class="col-fans">{{ item.fans }}</div>
              <div class="col-index">{{ item.index }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 达人热度指数 -->
      <div class="data-panel influencer-panel">
        <div class="panel-header">
          <div class="header-content">
            <h3 class="panel-title">达人热度指数</h3>
            <div class="panel-subtitle">以天为统计周期</div>
          </div>
        </div>
        <div class="panel-filters">
          <div class="filter-group">
            <label>选择媒体</label>
            <el-select v-model="selectedMedia" placeholder="请选择" size="small">
              <el-option v-for="item in mediaOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="filter-group">
            <label>选择行业</label>
            <el-select v-model="selectedIndustry" placeholder="请选择" size="small">
              <el-option v-for="item in industryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="panel-content">
          <div class="table-header influencer-header">
            <div class="col-rank">排名</div>
            <div class="col-name">账号名称</div>
            <div class="col-new-fans">新增粉丝</div>
            <div class="col-total-fans">累计粉丝</div>
            <div class="col-index">新增指数</div>
          </div>
          <div class="table-body">
            <div v-for="(item, index) in influencerData" :key="item.id" class="table-row influencer-row">
              <div class="col-rank">
                <div class="rank-number" :class="getRankClass(index)">{{ index + 1 }}</div>
                <div class="rank-change" :class="item.change > 0 ? 'up' : item.change < 0 ? 'down' : 'same'">
                  <span v-if="item.change > 0">▲</span>
                  <span v-else-if="item.change < 0">▼</span>
                  <span v-else-if="item.change !== 0">-</span>
                  <span v-if="item.change !== 0">{{ Math.abs(item.change) }}</span>
                </div>
              </div>
              <div class="col-name">
                <div class="user-info">
                  <img :src="item.avatar" :alt="item.name" class="user-avatar" />
                  <span class="user-name">{{ item.name }}</span>
                </div>
              </div>
              <div class="col-new-fans">{{ item.newFans }}</div>
              <div class="col-total-fans">{{ item.totalFans }}</div>
              <div class="col-index">{{ item.index }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homepage",
  data() {
    return {
      selectedMedia: '',
      selectedIndustry: '',
      selectedHotNewsMedia: 'weibo', // 默认选择微博
      hotNewsMediaOptions: [
        { value: 'weibo', label: '微博' },
        { value: 'douyin', label: '抖音' },
        { value: 'xiaohongshu', label: '小红书' },
        { value: 'kuaishou', label: '快手' },
        { value: 'bilibili', label: 'B站' }
      ],
      mediaOptions: [
        { value: 'weibo', label: '微博' },
        { value: 'douyin', label: '抖音' },
        { value: 'xiaohongshu', label: '小红书' },
        { value: 'kuaishou', label: '快手' },
        { value: 'bilibili', label: 'B站' }
      ],
      industryOptions: [
        { value: 'entertainment', label: '娱乐' },
        { value: 'fashion', label: '时尚' },
        { value: 'food', label: '美食' },
        { value: 'travel', label: '旅游' },
        { value: 'tech', label: '科技' }
      ],
      hotNewsData: {
        'weibo': [
          { id: 1, title: '未来一周热热热热热热热' },
          { id: 2, title: '黄子韬因为抢厕所要和徐艺洋分手' },
          { id: 3, title: '金靖爆改韩系美女' },
          { id: 4, title: '金价竟然涨到1000元' },
          { id: 5, title: '小米YU7续航实测结果' },
          { id: 6, title: '新能源汽车销量再创新高' },
          { id: 7, title: '春节档电影票房破纪录' },
          { id: 8, title: '人工智能技术新突破' },
          { id: 9, title: '网红直播带货新规发布' },
          { id: 10, title: '元宇宙概念股集体上涨' }
        ],
        'douyin': [
          { id: 1, title: '抖音年度热门挑战赛' },
          { id: 2, title: '短视频创作者收益新政' },
          { id: 3, title: '抖音直播带货破千万' },
          { id: 4, title: '网红打卡新地标' },
          { id: 5, title: '美食探店视频爆火' },
          { id: 6, title: '萌宠视频治愈系列' },
          { id: 7, title: '健身达人分享秘籍' },
          { id: 8, title: '旅行vlog记录美好' },
          { id: 9, title: '科技数码测评热潮' },
          { id: 10, title: '音乐创作原创力量' }
        ],
        'xiaohongshu': [
          { id: 1, title: '小红书种草好物推荐' },
          { id: 2, title: '美妆护肤心得分享' },
          { id: 3, title: '时尚穿搭灵感大全' },
          { id: 4, title: '居家生活改造tips' },
          { id: 5, title: '美食制作教程合集' },
          { id: 6, title: '旅游攻略详细指南' },
          { id: 7, title: '学习方法经验分享' },
          { id: 8, title: '健康养生生活方式' },
          { id: 9, title: '摄影技巧教学视频' },
          { id: 10, title: '手工DIY创意作品' }
        ],
        'kuaishou': [
          { id: 1, title: '快手老铁直播间' },
          { id: 2, title: '农村生活真实记录' },
          { id: 3, title: '手工艺人技能展示' },
          { id: 4, title: '家乡美食制作过程' },
          { id: 5, title: '传统文化传承故事' },
          { id: 6, title: '生活小窍门分享' },
          { id: 7, title: '宠物日常搞笑瞬间' },
          { id: 8, title: '音乐才艺展示舞台' },
          { id: 9, title: '创业经历真实分享' },
          { id: 10, title: '家庭生活温馨时刻' }
        ],
        'bilibili': [
          { id: 1, title: 'B站UP主创作激励' },
          { id: 2, title: '二次元文化热点' },
          { id: 3, title: '游戏实况解说精彩' },
          { id: 4, title: '知识科普视频爆火' },
          { id: 5, title: '动漫新番讨论热潮' },
          { id: 6, title: '学习资源免费分享' },
          { id: 7, title: '技术教程深度解析' },
          { id: 8, title: '音乐创作原创作品' },
          { id: 9, title: '生活vlog记录日常' },
          { id: 10, title: '影视解说精彩内容' }
        ]
      },
      celebrityData: [
        {
          id: 1,
          name: 'ACE-YOUNGKINGYOUNGBOSS',
          avatar: require('@/assets/hzt.jpg'),
          fans: '6643.36w',
          index: '794.9',
          change: 2
        },
        {
          id: 2,
          name: '肖战工作室',
          avatar: require('@/assets/xz.jpg'),
          fans: '1064.49w',
          index: '1050.0',
          change: 1
        },
        {
          id: 3,
          name: '曾舜晞Joseph',
          avatar: require('@/assets/zsx.jpeg'),
          fans: '2532.22w',
          index: '1107.9',
          change: -1
        },
        {
          id: 4,
          name: '时代少年团-丁程鑫',
          avatar: require('@/assets/dcx.jpg'),
          fans: '2625.98w',
          index: '1090.5',
          change: 0
        },
        {
          id: 5,
          name: 'TOP榜单心-朱一龙',
          avatar: require('@/assets/zyl.jpg'),
          fans: '898.5w',
          index: '1080.2',
          change: 3
        },
        {
          id: 6,
          name: '易烊千玺工作室',
          avatar: require('@/assets/yyqx.jpg'),
          fans: '1456.73w',
          index: '1075.8',
          change: -2
        },
        {
          id: 7,
          name: '王一博-WANGYIBO',
          avatar: require('@/assets/wyb.jpg'),
          fans: '1892.45w',
          index: '1068.9',
          change: 1
        },
        {
          id: 8,
          name: 'TOP榜单心-张若昀',
          avatar: require('@/assets/zry.jpg'),
          fans: '721.28w',
          index: '1055.4',
          change: 0
        },
        {
          id: 9,
          name: '杨幂工作室',
          avatar: require('@/assets/ym.jpeg'),
          fans: '1634.92w',
          index: '1048.7',
          change: 2
        },
        {
          id: 10,
          name: '迪丽热巴工作室',
          avatar: require('@/assets/dlrb.jpg'),
          fans: '1789.56w',
          index: '1042.3',
          change: -1
        }
      ],
      influencerData: [
        {
          id: 1,
          name: '谭乔',
          avatar: require('@/assets/tq.jpg'),
          newFans: '3.17w',
          totalFans: '622.5w',
          index: '942.3',
          change: 1
        },
        {
          id: 2,
          name: '颜值美妆',
          avatar: require('@/assets/2.jpg'),
          newFans: '4.69w',
          totalFans: '598.95w',
          index: '941.9',
          change: 0
        },
        {
          id: 3,
          name: '美小仙',
          avatar: require('@/assets/3.jpg'),
          newFans: '1219',
          totalFans: '1827.71w',
          index: '901.3',
          change: -2
        },
        {
          id: 4,
          name: '美妆大牌',
          avatar: require('@/assets/4.jpg'),
          newFans: '7761',
          totalFans: '548.78w',
          index: '866.8',
          change: 1
        },
        {
          id: 5,
          name: '时尚达人小王',
          avatar: require('@/assets/5.jpeg'),
          newFans: '2.34w',
          totalFans: '423.67w',
          index: '834.5',
          change: 3
        },
        {
          id: 6,
          name: '美食博主李姐',
          avatar: require('@/assets/6.jpg'),
          newFans: '1.89w',
          totalFans: '312.45w',
          index: '798.2',
          change: -1
        },
        {
          id: 7,
          name: '旅行摄影师张三',
          avatar: require('@/assets/7.jpg'),
          newFans: '5.23w',
          totalFans: '687.92w',
          index: '756.8',
          change: 2
        },
        {
          id: 8,
          name: '科技评测达人',
          avatar: require('@/assets/8.jpeg'),
          newFans: '3.45w',
          totalFans: '234.78w',
          index: '723.6',
          change: 0
        },
        {
          id: 9,
          name: '健身教练小刘',
          avatar: require('@/assets/9.jpg'),
          newFans: '2.78w',
          totalFans: '189.34w',
          index: '689.4',
          change: -3
        },
        {
          id: 10,
          name: '小仙女美妆',
          avatar: require('@/assets/10.jpg'),
          newFans: '1.06w',
          totalFans: '185.18w',
          index: '86.9',
          change: 0
        }
      ]
    }
  },
  computed: {
    hotNews() {
      return this.hotNewsData[this.selectedHotNewsMedia] || [];
    }
  },
  mounted() {
    // 初始化热点数据
    this.onHotNewsMediaChange();
  },
  methods: {
    onHotNewsMediaChange() {
      // 当媒体选择变化时，更新热点数据
      // 这里可以添加API调用来获取实时数据
      console.log('切换媒体:', this.selectedHotNewsMedia);
    },
    getRankClass(index) {
      if (index === 0) return 'rank-1'
      if (index === 1) return 'rank-2'
      if (index === 2) return 'rank-3'
      return 'rank-normal'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.homepage-container {
  padding: 0 32px 32px 32px;
  background: $background;
  min-height: calc(100vh - 84px);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

// 媒体热点速览
.hot-news-section {
  background: $card-bg;
  border-radius: $card-radius;
  padding: $card-padding;
  box-shadow: $card-shadow;
  transition: $transition;

  &:hover {
    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.06);
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border;

    .section-title {
      font-size: 20px;
      font-weight: 600;
      color: $text-main;
      margin: 0;
    }

    .refresh-info {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 14px;
      color: $text-secondary;

      .media-select {
        min-width: 120px;

        :deep(.el-input__inner) {
          font-size: 14px;
          border: 1px solid $border;
          border-radius: $input-radius;
          background: $input-bg;
        }

        :deep(.el-input__suffix) {
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }

  .hot-news-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;

    .hot-news-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px;
      border-radius: $radius;
      background: $secondary;
      transition: $transition;
      cursor: pointer;
      min-width: 0; // 允许容器收缩
      overflow: hidden; // 防止内容溢出

      &:hover {
        background: #e0e7ff;
        transform: translateY(-2px);
      }

      .news-rank {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 600;
        color: white;
        flex-shrink: 0;

        &.rank-1 {
          background: linear-gradient(135deg, #f59e0b, #fbbf24);
        }

        &.rank-2 {
          background: linear-gradient(135deg, $primary, $primary-light);
        }

        &.rank-3 {
          background: linear-gradient(135deg, $success, #4ade80);
        }

        &.rank-normal {
          background: $text-secondary;
        }
      }

      .news-content {
        font-size: 14px;
        color: $text-main;
        line-height: 1.5;
        flex: 1;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        position: relative;
        min-width: 0; // 允许flex项目收缩

        &:hover {
          color: $primary;
        }
      }
    }
  }
}

// 数据面板
.data-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  .data-panel {
    background: $card-bg;
    border-radius: $card-radius;
    padding: $card-padding;
    box-shadow: $card-shadow;
    transition: $transition;

    &:hover {
      box-shadow: 0 4px 16px rgba(37, 99, 235, 0.06);
    }

    .panel-header {
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 1px solid $border;

      .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .panel-title {
        font-size: 18px;
        font-weight: 600;
        color: $text-main;
        margin: 0;
      }

      .panel-subtitle {
        font-size: 13px;
        color: #9ca3af;
        font-weight: 400;
      }
    }

    .panel-filters {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 24px;
      padding: 0;

      .filter-group {
        display: flex;
        align-items: center;
        gap: 8px;

        label {
          font-size: 14px;
          color: $text-secondary;
          font-weight: 500;
          white-space: nowrap;
        }

        .el-select {
          width: 160px;

          :deep(.el-input__inner) {
            font-size: 14px;
            border: 1px solid $border;
            border-radius: 6px;
            background: #fff;
            color: $text-main;

            &:focus {
              border-color: $primary;
              box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
            }
          }

          :deep(.el-input__suffix) {
            color: $text-secondary;
          }
        }
      }
    }

    .panel-content {
      .table-header {
        display: grid;
        grid-template-columns: 8% 45% 20% 27%;
        gap: 12px;
        padding: 12px 16px;
        background: $table-header-bg;
        border-radius: $radius;
        margin-bottom: 12px;
        font-weight: 600;
        font-size: 14px;
        color: $text-secondary;

        &.influencer-header {
          grid-template-columns: 8% 35% 15% 20% 22%;
        }

        .col-rank {
          text-align: center;
        }

        .col-name {
          text-align: left;
          min-width: 0; // 允许列收缩
        }

        .col-fans,
        .col-index,
        .col-new-fans,
        .col-total-fans {
          text-align: center;
        }
      }

      .table-body {
        .table-row {
          display: grid;
          grid-template-columns: 8% 45% 20% 27%;
          gap: 12px;
          padding: 16px;
          border-radius: $radius;
          margin-bottom: 8px;
          transition: $transition;
          align-items: center;

          &.influencer-row {
            grid-template-columns: 8% 35% 15% 20% 22%;
          }

          &:hover {
            background: $table-row-hover;
          }

          .col-rank {
            position: relative;
            align-items: center;
            justify-content: center;

            .rank-number {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 11px;
              font-weight: 600;
              color: white;

              &.rank-1 {
                background: linear-gradient(135deg, #f59e0b, #fbbf24);
              }

              &.rank-2 {
                background: linear-gradient(135deg, $primary, $primary-light);
              }

              &.rank-3 {
                background: linear-gradient(135deg, $success, #4ade80);
              }

              &.rank-normal {
                background: $text-secondary;
              }
            }

            .rank-change {
              position: absolute;
              top: 100%;
              left: 10px;
              transform: translateX(-50%);
              font-size: 10px;
              font-weight: 500;

              &.up {
                color: $success;
              }

              &.down {
                color: $error;
              }

              &.same {
                color: $text-secondary;
              }
            }
          }

          .col-name {
            min-width: 0; // 允许列收缩
            overflow: hidden; // 防止内容溢出

            .user-info {
              display: flex;
              align-items: center;
              gap: 10px;
              min-width: 0; // 允许收缩

              .user-avatar {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                object-fit: cover;
                flex-shrink: 0; // 防止头像被压缩
              }

              .user-name {
                font-size: 14px;
                color: $text-main;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 0; // 允许文本收缩
                flex: 1; // 占据剩余空间
              }
            }
          }

          .col-fans,
          .col-index,
          .col-new-fans,
          .col-total-fans {
            text-align: center;
            font-size: 14px;
            color: $text-main;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .data-panels {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .homepage-container {
    padding: 0 16px 16px 16px;
    gap: 16px;
  }

  .hot-news-section {
    .hot-news-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    .hot-news-item {
      .news-content {
        font-size: 14px;
        line-height: 1.4;
      }
    }
  }

  .data-panels {
    .data-panel {
      .panel-content {
        .table-header {
          grid-template-columns: 10% 45% 20% 25%;
          gap: 8px;
          padding: 10px 12px;
          font-size: 13px;

          &.influencer-header {
            grid-template-columns: 10% 35% 15% 20% 20%;
          }
        }

        .table-body {
          .table-row {
            grid-template-columns: 10% 45% 20% 25%;
            gap: 8px;
            padding: 12px;

            &.influencer-row {
              grid-template-columns: 10% 35% 15% 20% 20%;
            }

            .col-rank {
              .rank-number {
                width: 18px;
                height: 18px;
                font-size: 10px;
              }

              .rank-change {
                left: 9px;
                font-size: 9px;
              }
            }

            .col-name {
              .user-info {
                gap: 8px;

                .user-avatar {
                  width: 24px;
                  height: 24px;
                }

                .user-name {
                  font-size: 13px;
                }
              }
            }

            .col-fans,
            .col-index,
            .col-new-fans,
            .col-total-fans {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .homepage-container {
    padding: 0 12px 12px 12px;
    gap: 12px;
  }

  .hot-news-section {
    .hot-news-list {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .hot-news-item {
      padding: 12px;
      gap: 8px;

      .news-rank {
        width: 24px;
        height: 24px;
        font-size: 12px;
      }

      .news-content {
        font-size: 13px;
        line-height: 1.3;
      }
    }
  }

  .data-panels {
    .data-panel {
      .panel-content {
        .table-header {
          grid-template-columns: 12% 45% 20% 23%;
          gap: 6px;
          padding: 8px 10px;
          font-size: 12px;

          &.influencer-header {
            grid-template-columns: 12% 35% 15% 18% 20%;
          }
        }

        .table-body {
          .table-row {
            grid-template-columns: 12% 45% 20% 23%;
            gap: 6px;
            padding: 10px;

            &.influencer-row {
              grid-template-columns: 12% 35% 15% 18% 20%;
            }

            .col-rank {
              .rank-number {
                width: 16px;
                height: 16px;
                font-size: 9px;
              }

              .rank-change {
                left: 8px;
                font-size: 8px;
              }
            }

            .col-name {
              .user-info {
                gap: 6px;

                .user-avatar {
                  width: 20px;
                  height: 20px;
                }

                .user-name {
                  font-size: 12px;
                }
              }
            }

            .col-fans,
            .col-index,
            .col-new-fans,
            .col-total-fans {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

.table-header>div,
.table-row>div {
  text-align: left !important;
}
</style>